import { useEffect } from "react";

import {
  getCookie,
  getCurrentZipcodeCookie
} from "@directv-digital/dds.services.cookie-service";
import { useZipCode } from "@directv-digital/dds.server.application-context";

const noop = () => undefined;

export const useRsnFeeHandler = () => {
  const { update: updateZipCode = noop } = useZipCode() ?? {};

  useEffect(() => {
    const handleMissingZipRsn = async () => {
      const zip = getCurrentZipcodeCookie();

      // Update zip code in context

      if (updateZipCode) {
        updateZipCode(zip, true);
      }
    };

    // Trigger fetch if cookie is missing

    if (!getCookie("rsnFee")) {
      handleMissingZipRsn();
    }
  }, [updateZipCode]);
};
